import React from "react";
import { formatINR } from "./Promotions/promoUtils";

/**
 * Shows the pricing breakdown (Total / Promo Discount / GST / Payable) for a request.
 *
 * The backend stores the GROSS amount on the request (`total_amount` / `price`) --
 * before the promo discount and before tax -- alongside `discount_amount` on the guest
 * request and `tax_amount` on the request itself, so:
 *   Total          = grossAmount
 *   Payable        = grossAmount - discountAmount + taxAmount
 *
 * GST is charged on the discounted amount, which is why the discount line sits above it.
 *
 * Renders nothing when there is neither a promo discount nor any tax to show.
 */
const PromoBreakdown = ({ grossAmount, discountAmount, taxAmount, promotionId }) => {
    const gross = Number(grossAmount) || 0;
    const discount = promotionId ? Number(discountAmount) || 0 : 0;
    const tax = Number(taxAmount) || 0;

    if (discount <= 0 && tax <= 0) return null;

    const payable = gross - discount + tax;

    return (
        <div className="flex flex-col gap-1 rounded-md border border-[#E3EFC9] bg-[#F7FAF0] p-3 text-sm">
            <div className="flex items-center justify-between text-[#8C9199]">
                <span>Total</span>
                <span>{formatINR(gross)}</span>
            </div>
            {discount > 0 && (
                <div className="flex items-center justify-between text-[#39471B]">
                    <span>Promo Discount</span>
                    <span>- {formatINR(discount)}</span>
                </div>
            )}
            {tax > 0 && (
                <div className="flex items-center justify-between text-[#8C9199]">
                    <span>GST</span>
                    <span>+ {formatINR(tax)}</span>
                </div>
            )}
            <div className="mt-1 flex items-center justify-between border-t border-[#E3EFC9] pt-1 font-semibold">
                <span>Payable</span>
                <span>{formatINR(payable)}</span>
            </div>
        </div>
    );
};

export default PromoBreakdown;
